import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
    map as _$ma,
} from 'intact';
import {Sender, Tag} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'ev-messageSend': this.onMessageSend,
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['beforeInput'] = function($super) {
                        return (
                            _$ce(2, 'div', [
                                _$ce(2, 'span', '试试这些问题：', 16, 'sender-demo-suggestions-title'),
                                _$ma(this.get('suggestions'), function($value, $key) {
                                    return _$cc(Tag, {
                                        'ev-click': this.pick.bind(this, $value),
                                        'children': $value
                                    });
                                }, $this)
                            ], 0, 'sender-demo-suggestions')
                        );
                    }),
                    (__$blocks['beforeInput'] = function($super, data) {
                        var block = $blocks['beforeInput'];
                        var callBlock = function() {
                            return _$blocks['beforeInput'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};